import { ReactElement, useCallback } from 'react';
import { HorizontalAlignEnum, VerticalAlignEnum } from '@utmb/types/modal';
import { DashboardModalProps } from '@utmb/types/dashboard-modal';
import { Modal } from '@utmb/design-system/modal/Modal';
import { UserEditWrapper } from '@utmb/features/user-edit-wrapper/UserEditWrapper';
import { UserEmailAcountForm } from '@utmb/features/my-utmb/user-email-account-form/UserEmailAccountForm';
import { UserEmailAcountValidation } from '@utmb/features/my-utmb/user-email-account-validation/user-email-account-validation';
import { useDashboard } from '@utmb/contexts/DashboardContext';
import { useTranslation } from 'next-i18next';

export const ModalEmailAccount = (props: DashboardModalProps): ReactElement => {
    const { t } = useTranslation();
    const { isOpen, close } = props;
    const { dashboardMember, refreshMember } = useDashboard();

    const closeCallback = useCallback(() => {
        close(!isOpen);
        refreshMember();
    }, [close, isOpen]);

    return (
        /* eslint-disable @typescript-eslint/no-empty-function */
        <Modal isOpen={isOpen} onClose={closeCallback} vAlign={VerticalAlignEnum.TOP} hAlign={HorizontalAlignEnum.RIGHT}>
            <UserEditWrapper title={t('myUtmb.email.title')}>
                {dashboardMember?.transfer ? (
                    <UserEmailAcountValidation closeCallback={closeCallback} transfer={dashboardMember.transfer} />
                ) : (
                    <UserEmailAcountForm closeCallback={closeCallback} />
                )}
            </UserEditWrapper>
        </Modal>
    );
};
